import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted px-4">
      <Card className="w-full max-w-md text-center">
        <CardHeader>
          <p className="mb-2 text-2xl font-bold tracking-tight text-primary">Farmly</p>
          <CardTitle className="text-xl">Här tar stigen slut</CardTitle>
          <CardDescription>
            Sidan finns inte längre – eller så blev länken fel.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col gap-3">
          <Button asChild>
            <Link to="/">Till startsidan</Link>
          </Button>
          <Button variant="outline" asChild>
            <Link to="/explore">Utforska</Link>
          </Button>
          <button
            type="button"
            onClick={() => window.history.back()}
            className="text-sm text-muted-foreground underline hover:text-foreground"
          >
            Gå tillbaka
          </button>
        </CardContent>
      </Card>
    </div>
  );
};

export default NotFound;
